import * as odataParser from 'odata-v4-parser';
import { DateParser } from './DateParser';
import { FilterVisitor } from './FilterVisitor';

export class ODataEvaluator {
  compileExpression(expression: any, dateParser?: DateParser) {
    const filterVisitor = new FilterVisitor(dateParser);
    const ast = (typeof expression === 'string' ? odataParser.filter(expression.trim()) : expression);
    return filterVisitor.Visit(ast, {});
  }

  evaluate(context: any, query: string, dateParser?: DateParser) {
    // console.log(query, context);
    const expression = this.compileExpression(query, dateParser);
    return expression(context);
  }
}
